import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { FORMAT_NUMBER } from '../../libs/utils/Const';

const borderColor = '#90e5fc'

const styles = StyleSheet.create({
    tableContainer: {
        width: '97%',
        marginTop: '75px',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    cell: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        fontSize: '8px',
        textAlign: 'center',
        paddingTop: '2px',
        paddingLeft: '2px'

    },
    row: {
        flexDirection: 'row',
        display: 'flex',
        height: 15,
        fontSize: 8,
    },
    signature1: {
        width: '30%',
        marginLeft: '50px'
    },
    signature2: {
        width: '30%',
        marginRight: '50px'
    },
    signatureSpace: {
        width: '40%',
    },
    titleSignature1: {
        width: '30%',
        marginLeft: '55px'
    },
    titleSignature2: {
        width: '30%',
        marginRight: '45px'
    },
    description: {
        width: '85%',
        textAlign: 'right',
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'center',
        paddingRight: 8,
        backgroundColor: '#e2e2e2',
        fontStyle: 'bold'
    },
});
const round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
}

const refreshTotal = (header, Items) => {
    Items.map(item => {
        item.TaxeResult = round(item.ImpuestoRow / (header.DocRate || 1)).toFixed(2);
        item.Total = round(item.LineTotal / (header.DocRate || 1)).toFixed(2);
    });
    let subTotal = 0;
    let impuestos = 0;
    let discount = 0;
    let total = 0;

    for (let index = 0; index < Items.length; index++) {
        const item = Items[index];
        item.TaxeResult = round(item.ImpuestoRow / (header.DocRate || 1)).toFixed(2);
        subTotal += Number(item.Total);
        impuestos += parseFloat(parseFloat(item.TaxeResult).toFixed(2));
    }

    discount = subTotal * (header.DiscPrcnt / 100);
    total = parseFloat(parseFloat(subTotal).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));

    let totals = {
        Subtotal: parseFloat(subTotal).toFixed(2),
        Discount: parseFloat(discount).toFixed(2),
        Taxes: parseFloat(impuestos).toFixed(2),
        Total: parseFloat(total).toFixed(2),
    }
    return totals;
};

const getTotalChargedMerch = (Lines) => {
    let document = {
        Total: 0.0
    };
    const balance = Lines.reduce((accumulator, transaction) => { return Number(accumulator) + Number(transaction?.LineWeightTotal); }, 0);
    if (!isNaN(balance)) document.Total = FORMAT_NUMBER.new(balance);
    return document;
}

const TableFooterMerchandise = ({ header, items, view }) => {
    const order = header.ObjType === "1250000001" ? getTotalChargedMerch(items) : refreshTotal(header, items);
    
    return (

        <View>
            {/* <View style={styles.row}>
                <Text style={styles.description}>Valor Bruto</Text>
                <Text style={styles.total}>{ Number.parseFloat(order.Total).toFixed(2)}</Text>
            </View> */}

            {/* <View style={styles.row}>
                <Text style={styles.description}>Subtotal</Text>
                <Text style={styles.total}>{ Number.parseFloat(order.Subtotal).toFixed(2)}</Text>
            </View> */}
            {/* <View style={styles.row}>
                <Text style={styles.description}>Descuento</Text>
                <Text style={styles.total}>{ Number.parseFloat(order.Discount).toFixed(2)}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>IVA</Text>
                <Text style={styles.total}>{ Number.parseFloat(order.Taxes).toFixed(2)}</Text>
            </View> */}
            {/* <View style={styles.row}>
                <Text style={styles.description}>ISC</Text>
                <Text style={styles.total}>{ Number.parseFloat(0).toFixed(2)}</Text>
            </View> */}
            {header.ObjType !== "1250000001" &&

                <View style={styles.row}>
                    <Text style={styles.description}>Total</Text>
                    <Text style={styles.total}>{Number.parseFloat(order.Total).toFixed(2)}</Text>
                </View>
            }

            {header.ObjType === "1250000001" &&

                <View style={styles.row}>
                    <Text style={styles.description}>Carga total</Text>
                    <Text style={styles.total}>{order.Total}</Text>
                </View>
            }

            {view === "transfers" &&
                <View style={styles.tableContainer}>
                    <View style={styles.tableRow}>
                        <View style={[styles.cell, styles.signature1]}>
                            <Text>{"-----------------------------------------------------"}</Text>
                        </View>
                        <View style={[styles.cell, styles.signatureSpace]}>
                            <Text>{" "}</Text>
                        </View>
                        <View style={[styles.cell, styles.signature2]}>
                            <Text>{"-----------------------------------------------------"}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.cell, styles.titleSignature1]}>
                            <Text>{"QUIEN RECIBE"}</Text>
                        </View>
                        <View style={[styles.cell, styles.signatureSpace]}>
                            <Text>{" "}</Text>
                        </View>
                        <View style={[styles.cell, styles.titleSignature2]}>
                            <Text>{"QUIEN ENTREGA"}</Text>
                        </View>
                    </View>
                </View>
            }
        </View>


    )
};

export default TableFooterMerchandise